import * as React from "react";
/* empty css                 */
const PRICE_SUFFIX_ID = "price-note";
const PriceSuffix = () => {
  return /* @__PURE__ */ React.createElement("a", { href: `#${PRICE_SUFFIX_ID}`, className: "product-block-price-suffix" }, "*");
};
export {
  PRICE_SUFFIX_ID,
  PriceSuffix
};
//# sourceMappingURL=PriceSuffix.js.map
